import React from 'react';

const SettingReportContext = React.createContext({
  isActionUpdate: false,
  masterdata: {},
  dispatchReport: () => {},
});

export default SettingReportContext;
